import { useEffect, useCallback, useState } from 'react';
import io from 'socket.io-client';
import useAuth from '@hooks/Auth/useAuth';
import { loadConfig } from '@api/api';

const useWebsocket = () => {
  const { accessToken, refreshTokens } = useAuth();
  const [socket, setSocket] = useState<ReturnType<typeof io> | null>(null);

  const connectWebsocket = useCallback(async () => {
    if (!accessToken) return;
    const BASE_URL = await loadConfig();
    const newSocket = io(BASE_URL, {
      transports: ['websocket'],
      path: '/ws',
      auth: { token: accessToken },
      reconnectionDelay: 10000,
      retries: 3,
    });
    setSocket(newSocket);

    return () => {
      newSocket.removeAllListeners();
      newSocket.disconnect();
    };
  }, [accessToken]);

  useEffect(() => {
    if (!accessToken) {
      socket?.disconnect();
      setSocket(null);
      return;
    }
    if (!socket && !document.hidden) {
      connectWebsocket();
    }
  }, [accessToken, connectWebsocket, socket]);

  useEffect(() => {
    if (!socket) return;

    socket.on('connect', () => {
      console.log('웹소켓 연결됨', socket.io.engine.transport.name);
    });

    socket.on('disconnect', (reason) => {
      console.log('웹소켓 연결 끊김', reason);
    });

    socket.on('status', (message) => {
      console.log('status', message.status);
      if (message.status === 404) {
        refreshTokens().then(() => connectWebsocket());
      }
    });

    socket.on('connect_error', (message) => {
      console.log(message);
    });

    socket.emit('mainWS', 'test message');

    return () => {
      socket.removeAllListeners();
    };
  }, [refreshTokens, setSocket, socket]);

  return socket;
}

export default useWebsocket;
